<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>

      <template>
        <v-dialog v-model="detaydialog" persistent max-width="500px">
          <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar color="info" size="120px" dark>
                <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-card-text>
              <v-container fluid="">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12>

                    <div v-for="item in objeler" :key="item.id">
                      <template v-if="item.type == 'S'">
                        <duzyaziinput :ref="item.vmodelname" :etiket="item.labeller" :id="item.vmodelname"
                          v-model="item.value"></duzyaziinput>
                      </template>

                      <template v-else-if="item.type == 'D'">
                        <tarihinput :etiket="item.labeller" v-bind:value="item.value" :id="item.vmodelname"
                          v-model="item.value"></tarihinput>
                      </template>

                      <template v-else-if="item.type == 'B'">
                        <sayiinput v-model="item.value" :autocomplete="autocomplete" :id="item.vmodelname"
                          :etiket="item.labeller"></sayiinput>
                      </template>

                      <template v-else-if="item.type == 'M'">
                        <moneyinput v-model="item.value" :autocomplete="autocomplete" :id="item.vmodelname"
                          :etiket="item.labeller"></moneyinput>
                      </template>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">



                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="sablondetaysil()" flat>
                    <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="detayguncelle()" flat>
                    <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                </v-tooltip>

              </div>
              <v-btn color="blue darken-1" flat @click.native="detaydialog=false">{{$t('Cancel')}}</v-btn>
              <div v-show="k === true">

                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="detaykaydet()" flat> <span
                      class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                    </span>
                  </v-btn>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                </v-tooltip>

              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template>
        <v-dialog v-model="yenikayitdialog" persistent max-width="500px">
          <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar color="info" size="120px" dark>
                <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-card-text>
              <v-flex pa-1 xs12 sm12 md12>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>

                      <v-layout row="" wrap="">
                        <v-flex xs12 sm12 md12>
                          <div v-for="item in objeler1" :key="item.id">

                            <template v-if="item.type == 'S'">
                              <duzyaziinput :ref="item.vmodelname" :etiket="item.labeller" :id="item.vmodelname"
                                v-model="item.value"></duzyaziinput>
                            </template>

                            <template v-else-if="item.type == 'D'">
                              <tarihinput :etiket="item.labeller" v-bind:value="item.value" :id="item.vmodelname"
                                v-model="item.value"></tarihinput>
                            </template>

                            <template v-else-if="item.type == 'B'">
                              <sayiinput v-model="item.value" :autocomplete="autocomplete" :id="item.vmodelname"
                                :etiket="item.labeller"></sayiinput>
                            </template>

                            <template v-else-if="item.type == 'M'">
                              <moneyinput v-model="item.value" :autocomplete="autocomplete" :id="item.vmodelname"
                                :etiket="item.labeller"></moneyinput>
                            </template>

                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="bkaydet" color="blue darken-1" flat @click="yenikayit()">{{$t("save_button")}}</v-btn>
              <v-btn color="blue darken-1" flat @click.native="yenikayitdialog=false">{{$t('Cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <v-dialog v-model="dialogaciklama" max-width="200px">
        <v-card>
          <v-card-title>
            {{$t('Area-ID-Disclosures')}}
          </v-card-title>
          <v-card-text>

            <v-flex xs12 sm12>
              <h3> S: {{$t('Plain-Text')}}.</h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> B: {{$t('Numeric')}} </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> D: {{$t('Date')}} </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> M: {{$t('Currency-Unit')}} </h3>
            </v-flex>

          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ekledialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-{xs through xl}="">
              <v-layout wrap>
                <div class="flex md12">
                  <v-text-field :label="$t('Template-Name')" hide-details="" v-model="Sablon.ProfileName" :color="color">
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">{{$t('Update')}}</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click="eklevazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="profilkaydet()">{{$t("save_button")}}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title class="baslikfont">{{$t('Profile-Template-Data-Entry')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="this.$t('Search')" append-icon="search">
        </v-text-field>

        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span class="hidden-sm-and-down">
              <span class="hidden-sm-and-down">{{$t('Add-Profile-Template')}}</span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{$t('Add-Profile-Template')}}</span>
        </v-tooltip>


        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>

            <v-list-tile @click.native="dialogaciklama=true">
              <v-list-tile-title>{{$t('Area-ID-Disclosures')}}</v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>
      </v-toolbar>
    </v-layout>

    <v-container fluid>
      <v-layout row wrap>


        <v-flex xs12 sm6 md6>
          <v-select :items="itemssablon" clearable item-value="ID" @change="detaygetir()" item-text="SablonAdi"
            :label="$t('Select-Template')" v-model="Sablon.TemplateID" hide-details=""></v-select>
        </v-flex>

        <v-flex xs12 v-if="detaykont">
          <v-card>
            <v-card-title>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="kayitekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t('Add')}}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t('Add')}}</span>
              </v-tooltip>

              <v-spacer></v-spacer>


            </v-card-title>



            <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="tabletumveriler" :loading="progress"
              :search="search3">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr @click="Getir(props.item)" item>

                  <td v-if="props.item!='ID'" v-for="header in props.item" :key="header.value" class="text-xs-left">
                    {{header}} </td>

                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 {{ $t('No-records-searched-for', { value: search3}) }}
              </v-alert>
            </v-data-table>

          </v-card>
          <template>
            <v-card>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
              </v-snackbar>
            </v-card>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import duzyaziinput from '@/components/app/customcomp/duzyaziinput.vue';
  import moneyinput from '@/components/app/customcomp/moneyinput.vue';
  import sayiinput from '@/components/app/customcomp/sayiinput.vue';
  import tarihinput from '@/components/app/customcomp/tarihinput.vue';
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"


  export default {
    data() {
      return {

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        i: 0,

        tabloalanisimleri: [],

        yedekalanid: [],

        yedekalanid1: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15',
          'S16', 'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29',
          'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],

        alanid: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15', 'S16',
          'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29', 'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],

        alanid1: [{
            value: 'S1',
            text: 'S1 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S2',
            text: 'S2 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S3',
            text: 'S3 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S4',
            text: 'S4 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S5',
            text: 'S5 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S6',
            text: 'S6 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S7',
            text: 'S7 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S8',
            text: 'S8 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S9',
            text: 'S9 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S10',
            text: 'S10 - ' + this.$t('Plain-Text') 
          },
          {
            value: 'S11',
            text: 'S11 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S12',
            text: 'S12 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S13',
            text: 'S13 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S14',
            text: 'S14 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S15',
            text: 'S15 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S16',
            text: 'S16 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S17',
            text: 'S17 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S18',
            text: 'S18 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S19',
            text: 'S19 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S20',
            text: 'S20 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S21',
            text: 'S21 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S22',
            text: 'S22 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S23',
            text: 'S23 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S24',
            text: 'S24 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S25',
            text: 'S25 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S26',
            text: 'S26 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S27',
            text: 'S27 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S28',
            text: 'S28 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S29',
            text: 'S29 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S30',
            text: 'S30 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S31',
            text: 'S31 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S32',
            text: 'S32 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S33',
            text: 'S33 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S34',
            text: 'S34 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S35',
            text: 'S35 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S36',
            text: 'S36 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S37',
            text: 'S37 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S38',
            text: 'S38 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S39',
            text: 'S39 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S40',
            text: 'S40 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S41',
            text: 'S41 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S42',
            text: 'S42 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S43',
            text: 'S43 - ' + this.$t('Plain-Text') 
          },
          {
            value: 'S44',
            text: 'S44 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S45',
            text: 'S45 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S46',
            text: 'S46 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S47',
            text: 'S47 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S48',
            text: 'S48 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S49',
            text: 'S49 - ' + this.$t('Plain-Text')
          },
          {
            value: 'S50',
            text: 'S50 - ' + this.$t('Plain-Text')
          },
          {
            value: 'D1',
            text: 'D1 - ' + this.$t('Date')
          },
          {
            value: 'D2',
            text: 'D2 - ' + this.$t('Date')
          },
          {
            value: 'D3',
            text: 'D3 - ' + this.$t('Date')
          },
          {
            value: 'D4',
            text: 'D4 - ' + this.$t('Date')
          },
          {
            value: 'D5',
            text: 'D5 - ' + this.$t('Date')
          },
          {
            value: 'D6',
            text: 'D6 - ' + this.$t('Date')
          },
          {
            value: 'D7',
            text: 'D7 - ' + this.$t('Date')
          },
          {
            value: 'D8',
            text: 'D8 - ' + this.$t('Date')
          },
          {
            value: 'D9',
            text: 'D9 - ' + this.$t('Date')
          },
          {
            value: 'D10',
            text: 'D10 - ' + this.$t('Date')
          },
          {
            value: 'B1',
            text: 'B1 - ' + this.$t('Numeric')
          },
          {
            value: 'B2',
            text: 'B2 - ' + this.$t('Numeric')
          },
          {
            value: 'B3',
            text: 'B3 - ' + this.$t('Numeric')
          },
          {
            value: 'B4',
            text: 'B4 - ' + this.$t('Numeric')
          },
          {
            value: 'B5',
            text: 'B5 - ' + this.$t('Numeric')
          },
          {
            value: 'B6',
            text: 'B6 - ' + this.$t('Numeric')
          },
          {
            value: 'B7',
            text: 'B7 - ' + this.$t('Numeric')
          },
          {
            value: 'B8',
            text: 'B8 - ' + this.$t('Numeric')
          },
          {
            value: 'B9',
            text: 'B9 - ' + this.$t('Numeric')
          },
          {
            value: 'B10',
            text: 'B10 - ' + this.$t('Numeric')
          },
          {
            value: 'M1',
            text: 'M1 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M2',
            text: 'M2 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M3',
            text: 'M3 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M4',
            text: 'M4 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M5',
            text: 'M5 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M6',
            text: 'M6 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M7',
            text: 'M7 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M8',
            text: 'M8 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M9',
            text: 'M9 - ' + this.$t('Currency-Unit')
          },
          {
            value: 'M10',
            text: 'M10 - ' + this.$t('Currency-Unit')
          },
        ],
        values: [],

        evethayir: [{
            text: this.$t('Yes'),
            value: 'E'
          },

          {
            text: 'Hayır',
            value: 'H'
          }
        ],

        objeler: [],
        objeler1: [],

        upid: '',
        upsablonid: '',
        autocomplete: 'autocomplete',

        tabletumveriler: [],
        loading: false,
        color: 'orange darken-4',
        items: [],
        itemssablon: [],
        search3: '',
        search: null,
        select: [],
        detaykont: false,
        selected: '',
        m: false,
        k: false,
        detaydialog: false,
        dialogaciklama: false,
        renk1: 'info',
        ekledialog: false,
        SablonDetay: {
          ID: '',
          SablonID: '',
          AlanID: '',
          AlanAdi: '',
          Zorunlu: '',
          Fatura: '',
          AmedeusKod: '',
          GalileoKod: '',
          Anahtar: ''
        },

        Sablon: {
          ProfileName: '',
          TemplateID: '',
          DetailID: '',
          ProfileID: ''
        },

        state: [],
        yenikayitdialog: false,
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        yedekkod: '',
        control: 0,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },

    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    components: {
      'duzyaziinput': duzyaziinput,
      'moneyinput': moneyinput,
      'sayiinput': sayiinput,
      'tarihinput': tarihinput,
      yetkidialog
    },
    methods: {
      Getir(v) {
        this.upid = v.ID
        this.detaydialog = true
        var i = 0
        var secilikayit = []
        Object.keys(v).forEach(key => {
          var NewObject = {};
          var NewObject1 = {};
          NewObject[Object.keys(v)[i]] = v[key]
          if (Object.keys(v)[i] == 'SablonID') {
            NewObject['type'] = 'SI'
          } else {
            NewObject['type'] = Object.keys(v)[i].substr(0, 1)
          }

          NewObject['vmodelname'] = Object.keys(v)[i]
          var sira = this.tabloalanisimleri.findIndex(x => x.value === Object.keys(v)[i]);
          var labeldegeri = this.tabloalanisimleri[sira].text
          NewObject['labeller'] = labeldegeri
          NewObject['value'] = v[key]
          i = i + 1
          secilikayit.push(NewObject)
        });

        this.objeler = secilikayit

        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Şablon Veri Girişi Güncelle'
      },
      ekle: ekle,
      eklevazgec: eklevazgec,
      profilkaydet: profilkaydet,
      guncelle: guncelle,
      vazgec: vazgec,
      detaygetir: detaygetir,
      kayitekle: kayitekle,
      yenikayit: yenikayit,
      sablondetaysil: sablondetaysil,
      detayguncelle: detayguncelle
    },

    mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          SirketKodu: credentials.SirketKodu
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemssablon = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    vazgec: vazgec
  }


  function kayitekle() {


    this.yenikayitdialog = true
    this.dialog_baslik = "Profil Şablon Veri Ekle"

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu,
      TemplateID: this.Sablon.TemplateID
    }

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      var yenikayit = []
      response.body.forEach(element => {
        var NewObject = {};
        NewObject['type'] = element.AlanID.substr(0, 1)
        NewObject['labeller'] = element.AlanAdi
        NewObject['vmodelname'] = element.AlanID
        NewObject['value'] = null
        yenikayit.push(NewObject)
      });

      this.objeler1 = yenikayit

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })



  }

  function yenikayit() {

    this.upid = ''
    this.upsablonid = ''
    var detayobject = {};
    var duzenlenenveri = {}

    var duzenlenenkayit = []
    var Veriler = []

    this.objeler1.forEach(element => {

      if (element.type != 'I' && element.type != 'SI') {
        var duzenlenenveri = {}
        var element1 = document.getElementById(element.vmodelname);
        if (element1 != null) {
          duzenlenenveri['AlanAdi'] = element.labeller
          duzenlenenveri['AlanID'] = element1.id

          if (element.type === 'M') {
            var yedekveri = element1.value
            yedekveri = yedekveri.replace("₺", "")
            yedekveri = yedekveri.replace(",", "")
            duzenlenenveri['Veri'] = yedekveri
          } else if (element.type === 'B') {
            var yedekveri = element1.value
            yedekveri = yedekveri.replace(",", "")
            duzenlenenveri['Veri'] = yedekveri
          } else {
            duzenlenenveri['Veri'] = element1.value
          }



          if (element.type === 'D') {
            var parts = element1.value.split(".");
            var yedekveridate = parts[2] + '-' + parts[1] + '-' + parts[0]
            duzenlenenveri['Veri'] = yedekveridate
          }

        } else {}

        Veriler.push(duzenlenenveri)

      }

    });


    detayobject['Veriler'] = Veriler
    detayobject['ID'] = null
    detayobject['SablonID'] = this.Sablon.TemplateID
    duzenlenenkayit.push(detayobject)
    var params = detayobject
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.yenikayitdialog = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.tabletumveriler = []
        this.tabloalanisimleri = []
        this.headers = []
        var ID = {
          text: 'ID',
          value: 'ID',
        }
        this.tabloalanisimleri.push(ID)

        var Sablon = {
          text: 'Şablon ID',
          value: 'SablonID',
        }
        this.tabloalanisimleri.push(Sablon)

        //alan adlarını alalım
        response.body[0].Veriler.forEach(element => {

          var kayit = {
            text: element.AlanAdi,
            value: element.AlanID,
          }
          this.tabloalanisimleri.push(kayit)
        });


        this.headers = this.tabloalanisimleri
        var tumveriler = []

        //alanların içeriğini bulalım
        response.body.forEach(element => {
          var ID = element.ID
          var sablonid = element.SablonID
          var i;
          var veriler = []
          var NewObject = {};
          NewObject['ID'] = ID;
          NewObject['SablonID'] = sablonid

          for (i = 0; i < element.Veriler.length; i++) {
            NewObject[element.Veriler[i].AlanID] = element.Veriler[i].Veri;
          }
          tumveriler.push(NewObject)

        });
        this.tabletumveriler = tumveriler
        this.detaykont = true
        this.progress = false

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        } else {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })


  }

  function sablondetaysil() {
    if (window.confirm('Detay\'ı silmek istediğinize emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        DataID: this.upid,
        TemplateID: this.Sablon.TemplateID,
        CompanyCode: credentials.SirketKodu
      }
      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.detaydialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            TemplateID: this.SablonDetay.SablonID
          }

          this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.detaykont = true
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function detayguncelle() {

    this.upid = ''
    this.upsablonid = ''
    var detayobject = {};
    var duzenlenenveri = {}

    var duzenlenenkayit = []
    var Veriler = []
    this.objeler.forEach(element => {

      if (element.type == 'I') {
        this.upid = element.value
      }

      if (element.type == 'SI') {
        this.sablonid = element.value
      }

      if (element.type != 'I' && element.type != 'SI') {
        var duzenlenenveri = {}
        var element1 = document.getElementById(element.vmodelname);
        if (element1 != null) {
          duzenlenenveri['AlanAdi'] = element.labeller
          duzenlenenveri['AlanID'] = element1.id

          if (element.type === 'M') {
            var yedekveri = element1.value
            yedekveri = yedekveri.replace("₺", "")
            yedekveri = yedekveri.replace(",", "")
            duzenlenenveri['Veri'] = yedekveri
          } else if (element.type === 'B') {
            var yedekveri = element1.value
            yedekveri = yedekveri.replace(",", "")
            duzenlenenveri['Veri'] = yedekveri
          } else {
            duzenlenenveri['Veri'] = element1.value
          }

          if (element.type === 'D') {
            var parts = element1.value.split(".");
            var yedekveridate = parts[2] + '-' + parts[1] + '-' + parts[0]
            duzenlenenveri['Veri'] = yedekveridate
          }

        } else {}
        Veriler.push(duzenlenenveri)
      }
    });

    detayobject['Veriler'] = Veriler
    detayobject['ID'] = this.upid
    detayobject['SablonID'] = this.sablonid
    duzenlenenkayit.push(detayobject)
    var params = detayobject
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataUpdate', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.detaydialog = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.tabletumveriler = []
        this.tabloalanisimleri = []
        this.headers = []

        var ID = {
          text: 'ID',
          value: 'ID',
        }
        this.tabloalanisimleri.push(ID)

        var Sablon = {
          text: 'Şablon ID',
          value: 'SablonID',
        }
        this.tabloalanisimleri.push(Sablon)

        //alan adlarını alalım
        response.body[0].Veriler.forEach(element => {

          var kayit = {
            text: element.AlanAdi,
            value: element.AlanID,
          }
          this.tabloalanisimleri.push(kayit)
        });



        this.headers = this.tabloalanisimleri
        var tumveriler = []

        //alanların içeriğini bulalım
        response.body.forEach(element => {
          var ID = element.ID
          var sablonid = element.SablonID
          var i;
          var veriler = []
          var NewObject = {};
          NewObject['ID'] = ID;
          NewObject['SablonID'] = sablonid

          for (i = 0; i < element.Veriler.length; i++) {
            NewObject[element.Veriler[i].AlanID] = element.Veriler[i].Veri;
          }
          tumveriler.push(NewObject)

        });
        this.tabletumveriler = tumveriler
        this.detaykont = true
        this.progress = false

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        } else {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function eklevazgec() {
    this.ekledialog = false
    this.Sablon.ProfileName = null
  }

  function vazgec() {
    this.dialog = false
    this.search = ''
  }

  function detaygetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
      TemplateID: this.Sablon.TemplateID
    }

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.tabletumveriler = []
      this.tabloalanisimleri = []
      this.headers = []

      var ID = {
        text: 'ID',
        value: 'ID',
      }
      this.tabloalanisimleri.push(ID)

      var Sablon = {
        text: 'Şablon ID',
        value: 'SablonID',
      }
      this.tabloalanisimleri.push(Sablon)

      //alan adlarını alalım
      response.body[0].Veriler.forEach(element => {

        var kayit = {
          text: element.AlanAdi,
          value: element.AlanID,
        }
        this.tabloalanisimleri.push(kayit)
      });




      this.headers = this.tabloalanisimleri

      var tumveriler = []

      //alanların içeriğini bulalım
      response.body.forEach(element => {
        var ID = element.ID
        var sablonid = element.SablonID
        var i;
        var veriler = []
        var NewObject = {};
        NewObject['ID'] = ID;
        NewObject['SablonID'] = sablonid

        for (i = 0; i < element.Veriler.length; i++) {
          NewObject[element.Veriler[i].AlanID] = element.Veriler[i].Veri;
        }

        tumveriler.push(NewObject)

      });
      this.tabletumveriler = tumveriler
      this.detaykont = true
      this.progress = false

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }



  function profilkaydet() {


    var params = this.Sablon

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.detaydialog = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.itemssablon = response.body
        this.ekledialog = false
        this.detaykont = false
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })

  }

  function ekle() {
    this.ekledialog = true
    this.dialog_baslik = 'Yeni Şablon Ekle'
    this.k = true
    this.m = false
    this.$validator.reset()
  }

  function beforeMount() {

  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu
        var params = this.MusteriPersonel
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            var params1 = {
              SirketKodu: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>